export const SET_INBOX_MAGAZINE = 'SET_INBOX_MAGAZINE'
export const SET_OUTBOX_MAGAZINE = 'SET_OUTBOX_MAGAZINE'
export const SET_SELL_MAGAZINE = 'SET_SELL_MAGAZINE'
export const CLEAR_SELL_MAGAZINE = 'CLEAR_SELL_MAGAZINE'